import { makeVar } from "@apollo/client";

const profilePicVar = makeVar(undefined);

export default profilePicVar;
